import NameApplicantField from './NameApplicantField';

export default NameApplicantField;
